import React, {useCallback, useEffect, useRef, useState} from 'react';
import KebabButton from '../../../../uiToolkit/KebabButton';
import styles from './MicroreelCardOptions.module.css';

interface MenuOption {
  label: string;
  onClick: () => void;
  danger?: boolean;
  disabled?: boolean;
}

interface Props {
  options: MenuOption[];
  ariaLabel?: string;
}

const MicroreelCardOptions = React.memo(({options, ariaLabel}: Props) => {
  const [showOptions, setShowOptions] = useState(false);

  const openerRef = useRef<any>(null);
  const menuRef = useRef<any>(null);

  const handleBodyClick = useCallback(
    (ev: any) => {
      if (
        showOptions &&
        openerRef?.current !== ev.target &&
        !menuRef?.current?.contains(ev.target)
      ) {
        setShowOptions(false);
      }
    },
    [showOptions],
  );

  useEffect(() => {
    // capture: card wrappers stop propagation of clicks on other openers
    window.addEventListener('click', handleBodyClick, true);
    return () => {
      window.removeEventListener('click', handleBodyClick, true);
    };
  }, [handleBodyClick]);

  return (
    <div className={styles.menuContainer}>
      <KebabButton
        isOpen={showOptions}
        onClick={() => setShowOptions(!showOptions)}
        ref={openerRef}
        ariaLabel={ariaLabel}
      />
      {showOptions && (
        <div className={styles.menu} ref={menuRef}>
          {options.map(option => (
            <div
              key={option.label}
              className={`${styles.option} ${
                option.danger ? styles.danger : ''
              } ${option.disabled ? styles.optionDisabled : ''}`}
              onClick={() => {
                if (option.disabled) return;
                option.onClick();
                setShowOptions(false);
              }}>
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
});

export default MicroreelCardOptions;
